import React,{useEffect, useRef, useState} from 'react';
import '../styles/ScrollArrows.css'
const ScrollArrows = ({currentStage})=>{
    const [stage,setStage] = useState(currentStage)
    const [set,setSet] = useState(false)
    useEffect(()=>{
        setStage(false)
        
    if(currentStage===3 && !set){
        setStage(true)
        setSet(true)
    }
    },[currentStage])
    return(
        <div className="arrow" style={{opacity:stage?1:0}}>
        <span></span>
        <span></span>
        <span></span>
    </div>
    )
}
export default ScrollArrows;